// removed by extract-text-webpack-plugin
module.exports = {"app":"AppPrint__app___3biDE"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/AppPrint.scss
 ** module id = 646
 ** module chunks = 0
 **/